import { Box, Text } from '@wix/design-system';
import { ECLIPSE_BG } from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import styles from './FeaturesGridNewBadge.scss';

interface FeaturesGridNewBadgeProps {
  upperCase?: boolean;
  dataHook?: string;
}

export const FeaturesGridNewBadge = ({
  upperCase = true,
  dataHook,
}: FeaturesGridNewBadgeProps) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();

  const text = upperCase
    ? t('features.new_feature.new_badge').toUpperCase()
    : t('features.new_feature.new_badge');

  return (
    <Box
      backgroundColor={ECLIPSE_BG}
      borderRadius="4px"
      padding="0 6px"
      height="18px"
      dataHook={dataHook}
    >
      <Text
        size="tiny"
        skin="standard"
        weight="bold"
        className={styles.newBadge}
      >
        {text}
      </Text>
    </Box>
  );
};
